// Handles syncing guest cart to user account on login

function syncCartWithAccount() {
    const user = frappe?.session_info?.user;
    if (!user || user === 'Guest') return;

    frappe.call({
        method: 'frappe.client.get_value',
        args: {
            doctype: 'User',
            filters: { name: user },
            fieldname: 'user_type'
        },
        callback: (r) => {
            if (r.message?.user_type === 'Website User') {
                mergeGuestCartWithUserCart(user);
            }
        }
    });
}

function mergeGuestCartWithUserCart(user) {
    const guestCart = JSON.parse(localStorage.getItem('temp_cart_items') || '[]');
    if (!guestCart.length) return;

    frappe.call({
        method: 'frappe.client.get_list',
        args: {
            doctype: 'Shopping Cart',
            filters: { user },
            fields: ['name']
        },
        callback: (res) => {
            const cartId = res.message?.[0]?.name;
            cartId ? updateUserCart(cartId, guestCart) : createUserCart(user, guestCart);
        }
    });
}

function updateUserCart(cartId, localItems) {
    frappe.call({
        method: 'frappe.client.get',
        args: { doctype: 'Shopping Cart', name: cartId },
        callback: (res) => {
            const serverItems = res.message?.items || [];
            const merged = mergeItems(serverItems, localItems);
            frappe.call({
                method: 'frappe.client.set_value',
                args: {
                    doctype: 'Shopping Cart',
                    name: cartId,
                    fieldname: 'items',
                    value: merged
                },
                callback: () => {
                    clearGuestCart();
                }
            });
        }
    });
}

function createUserCart(user, items) {
    frappe.call({
        method: 'frappe.client.insert',
        args: {
            doc: {
                doctype: 'Shopping Cart',
                user,
                items
            }
        },
        callback: clearGuestCart
    });
}

function mergeItems(serverItems, localItems) {
    const merged = [...serverItems];
    localItems.forEach(item => {
        const existing = merged.find(i => i.item_code === item.item_code);
        if (existing) existing.qty += item.qty;
        else merged.push(item);
    });
    return merged;
}

function clearGuestCart() {
    localStorage.removeItem('temp_cart_items');
    localStorage.removeItem('temp_cart_id');
    updateCartIndicator();
}

document.addEventListener('DOMContentLoaded', () => {
    frappe?.session_info ? syncCartWithAccount() : document.addEventListener('frappe:ready', syncCartWithAccount);
});